// easyui-layout.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';

declare let $: any;

@Component({
  selector: 'easyui-layout',
  template: `
		<div style="height: 100%">
			<div #host>
				<ng-content></ng-content>
			</div>
		</div>
	`,
})
export class EasyuiLayoutComponent implements AfterViewInit {
	private host: any;
	@ViewChild('host') hostElement: ElementRef;
	@Input('options') options: any = {};

	constructor() {
	}

	ngAfterViewInit() {
		this.configura(this.options);
	}

	public addPanel(options: any) {
		this.host.layout('add', options);
	}

	public getPanel(panel: string) {
		return this.host.layout('panel', panel);
	}

	public resize(width: any, height: any) {
		this.host.layout('resize', {width, height});
	}

	public resizeHeight(panel: string, size: any) {
		const p = this.host.layout('panel', panel);
		p.panel('resize', {height: size});
	}

	public resizeWidth(panel: string, size: any) {
		const p = this.host.layout('panel', panel);
		p.panel('resize', {width: size});
	}

	public refresh(panel: string) {
		const p = this.host.layout('panel', panel);
		if (p) { p.panel('refresh'); }
	}

	public doLayout(panel: string) {
		const p = this.host.layout('panel', panel);
		if (p) { p.panel('doLayout'); }
	}

	public expand(panel: string) {
		this.host.layout('expand', panel);
	}

	public collapse(panel: string) {
		this.host.layout('collapse', panel);
	}

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
	}

	// metodi privati

	private configura(options: any) {
		this.host = $(this.hostElement.nativeElement);
		if (!options.fit) { options.fit = true; }
		this.host.layout(options);
	}
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-layout.component.ts